<div class="card-product -title">
  @if (largetitle) {
  <div class="-text-caption -fontDisplayThin">{{ largetitle }}</div>
  }
  <h3>{{ title }}</h3>
</div>
<ng-content></ng-content>
